import { render, staticRenderFns } from "./SystemCustomNotificationsList.vue?vue&type=template&id=f00417c0"
import script from "./SystemCustomNotificationsList.vue?vue&type=script&lang=js"
export * from "./SystemCustomNotificationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports